import { createApp } from 'vue'
import App from './App.vue'
import { Button,
    Form,
    Field,
    CellGroup,
    RadioGroup,
    Radio,
    Cell,
    DatePicker,
    Popup,
    Image  as VanImage,
    Col,
    Row,
    Dialog,
    TextEllipsis,
    Divider,
    FloatingBubble,
    NavBar,Tag,
    ContactCard,Search,
    Collapse, CollapseItem,Icon,SwipeCell,
    NoticeBar,Uploader,Checkbox,CheckboxGroup,ImagePreview,IndexBar,IndexAnchor,Step,Steps,Space,Popover,Picker
} from 'vant';
import VueCookies from "vue-cookies";
import 'vant/lib/index.css';
import 'vant/lib/index.js';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import router from './router'
import { PickerGroup,TimePicker  } from 'vant';

const app = createApp(App);
app.use(Button).use(Form).use(Field).use(PickerGroup).use(TimePicker)
    .use(CellGroup).use(RadioGroup)
    .use(Radio).use(Cell).use(DatePicker)
    .use(Popup).use(VanImage).use(Col).use(Tag)
    .use(Row).use(Dialog).use(TextEllipsis)
    .use(Divider).use(FloatingBubble).use(NavBar).use(Icon).use(Search)
    .use(ContactCard).use(router).use(Collapse).use(CollapseItem).use(NoticeBar).use(SwipeCell)
    .use(VueCookies).use(Uploader).use(Checkbox).use(CheckboxGroup).use(ImagePreview).use(IndexBar).use(IndexAnchor).use(Step).use(Steps).use(Space).use(Popover).use(Picker).use(ElementPlus)
app.mount('#app');

